import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'monthName',
})
export class MonthNamePipe implements PipeTransform {
  private monthNames = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dez',
  ];

  transform(value: number | null): string {
    return value !== null ? `app.months.${this.monthNames[value]}` : 'app.unknown';
  }
}
